import { render, staticRenderFns } from "./promotion-edit.vue?vue&type=template&id=3a316b9c&scoped=true"
import script from "./promotion-edit.vue?vue&type=script&lang=js"
export * from "./promotion-edit.vue?vue&type=script&lang=js"
import style0 from "./promotion-edit.vue?vue&type=style&index=0&id=3a316b9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a316b9c",
  null
  
)

export default component.exports